import React from 'react'
import { observer } from 'mobx-react'
import Card from './Card'
import { companyPageWidgets } from './SalesIntelligenceWidgets'
import AiSummaryWidget from './widgets/AiSummaryWidget'
import EEM from '../DynamicDashV3/charts/EEM'
import FindExhibitor from './widgets/FindExhibitor'

const CompanyView = observer(({ style, cssClass, salesIntelligenceStore }) => {
    const { aiSummary, salesIntelligenceMatrix, exhibitorsList } = companyPageWidgets
    const { companyPageData } = salesIntelligenceStore
    const noExhibitorQuestion = salesIntelligenceStore?.companyPageData?.exhibitorList?.error
    const summaryStyle = { ...aiSummary.style, ...(noExhibitorQuestion && { gridColumnEnd: 'span 12' }) }
    if (!companyPageData) return null
    return (
        <div
            className={`salesInt-cards widgetContainer ${cssClass ?? ''}`}
            style={style}
        >
            <Card cssClass={aiSummary.gridClass} style={summaryStyle}>
                <AiSummaryWidget
                    appStore={salesIntelligenceStore.appStore}
                    surveyId={salesIntelligenceStore.surveyId}
                    exhibitorName="AI"
                    pageType="company"
                />
            </Card>
            {salesIntelligenceStore?.companyPageData?.salesIntelligenceMatrix?.error
                ? null
                : (
                    <Card cssClass={salesIntelligenceMatrix.gridClass} style={salesIntelligenceMatrix.style}>
                        <EEM
                            chartData={[salesIntelligenceStore?.companyPageData?.salesIntelligenceMatrix]}
                            segmentNameOverride={{
                                RECALIBRATOR: 'Committed Under-performers',
                                PROGRESSIVE: 'Committed Performers',
                                DISENGAGED: 'Sceptical Under-performers',
                                PROSPECTOR: 'Sceptical Performers',
                            }}
                        />
                    </Card>
                )}
            {noExhibitorQuestion
                ? null
                : (
                    <Card cssClass={exhibitorsList.gridClass} style={exhibitorsList.style}>
                        <FindExhibitor
                            chartData={salesIntelligenceStore?.companyPageData?.exhibitorList}
                            onLinkClick={(e, company) => {
                                e.preventDefault()
                                salesIntelligenceStore.changeExhibitor({ value: company })
                                salesIntelligenceStore.changePage('exhibitorView')
                            }}
                        />
                    </Card>
                )}
        </div>
    )
})

export default CompanyView
